var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconGolden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1657_567)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1657_567",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V14H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1657_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50812 14H2.49207C2.27899 14.0014 2.07292 13.9167 1.9133 13.762C1.75557 13.6067 1.65758 13.3915 1.63914 13.16L0.853027 4.2H11.1462L10.3601 13.16C10.3401 13.3895 10.2423 13.6024 10.0859 13.7566C9.92752 13.9135 9.72159 14.0002 9.50812 14ZM8.15306 6.5283C8.03856 6.52802 7.92863 6.57752 7.84739 6.66595C7.76615 6.75438 7.72024 6.87451 7.71972 7V11.2C7.71972 11.326 7.76537 11.4468 7.84664 11.5358C7.92791 11.6249 8.03813 11.6749 8.15306 11.6749C8.26799 11.6749 8.37821 11.6249 8.45948 11.5358C8.54075 11.4468 8.5864 11.326 8.5864 11.2V7C8.58588 6.87451 8.53997 6.75438 8.45873 6.66595C8.37749 6.57752 8.26756 6.52802 8.15306 6.5283ZM5.99911 6.5283C5.88529 6.52915 5.77637 6.57916 5.69598 6.66746C5.61559 6.75577 5.57021 6.87526 5.5697 7V11.2C5.5697 11.326 5.61536 11.4468 5.69662 11.5358C5.77789 11.6249 5.88811 11.6749 6.00304 11.6749C6.11797 11.6749 6.2282 11.6249 6.30946 11.5358C6.39073 11.4468 6.43639 11.326 6.43639 11.2V7C6.43613 6.93759 6.42463 6.87585 6.40254 6.81833C6.38045 6.7608 6.34821 6.70863 6.30767 6.6648C6.26713 6.62097 6.21909 6.58635 6.16631 6.56293C6.11352 6.5395 6.05606 6.52774 5.99911 6.5283ZM3.85892 6.5283C3.74442 6.52802 3.6345 6.57752 3.55326 6.66595C3.47202 6.75438 3.4261 6.87451 3.42558 7V11.2C3.42558 11.326 3.47123 11.4468 3.5525 11.5358C3.63377 11.6249 3.74399 11.6749 3.85892 11.6749C3.97385 11.6749 4.08408 11.6249 4.16534 11.5358C4.24661 11.4468 4.29227 11.326 4.29227 11.2V7C4.29175 6.8747 4.24597 6.75473 4.16494 6.66633C4.08391 6.57793 3.97325 6.5283 3.85892 6.5283Z",
    fill: "#C9C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1473 1.4H7.72081V0.928308C7.72081 0.805764 7.69868 0.684432 7.65568 0.57131C7.61268 0.458188 7.54968 0.355516 7.47029 0.269215C7.39091 0.182915 7.29672 0.114694 7.19316 0.0684879C7.08959 0.0222818 6.97871 -0.000995043 6.8669 9.40781e-08H5.14728C5.03555 -0.000852245 4.92477 0.02253 4.82132 0.0688001C4.71787 0.11507 4.6238 0.183314 4.54452 0.2696C4.46524 0.355886 4.40232 0.45851 4.35938 0.571561C4.31644 0.684612 4.29434 0.805855 4.29434 0.928308V1.4H0.853139C0.628491 1.4 0.413045 1.4978 0.254195 1.6719C0.0953445 1.84599 0.00610352 2.08211 0.00610352 2.32831C0.00610352 2.57451 0.0953445 2.81063 0.254195 2.98472C0.413045 3.15881 0.628491 3.25662 0.853139 3.25662H11.1473C11.3719 3.25662 11.5874 3.15881 11.7462 2.98472C11.9051 2.81063 11.9943 2.57451 11.9943 2.32831C11.9943 2.08211 11.9051 1.84599 11.7462 1.6719C11.5874 1.4978 11.3719 1.4 11.1473 1.4Z",
    fill: "#C9C288"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1657_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGolden);
export default __webpack_public_path__ + "static/media/delete-icon-golden.91358370.svg";
export { ForwardRef as ReactComponent };